import { AxiosRequestConfig } from 'axios';

export function performBaseUrlAppenderInterceptor(config: AxiosRequestConfig): AxiosRequestConfig {
  if (!config.url.startsWith('/api/v0')) {
    config.url = `/api/v0${config.url}`;
  }

  return config;
}
